export const allowedModules = [
  {
    name: 'commerce',
    dashboardUrl: '/dashboard',
    dashBoardPermission: 'DASHBOARD_PAYMENTS_READ',
    modules: [
      "dashboard",
      "analytics",
      "customers",
      "products",
      'inventory',
      "quotations",
      "orders",
      "invoices",
      "recurringInvoices",
      "creditNotes",
      "debitNotes",
      'receipts',
      'statement',
      "bills",
      "cashPurchases",
      "suppliers",
      "suppliers",
      "brands",
      "email",
      "reports",
      "categories",
      "profile",
      "settings",
      "pos",
      "accounting",
      "more",
      'communications',
      'projects',
    ],
    domains: [
      'customer.salesdue.com', 
      'customer.modial.co',
      'modial.local:4002',
      'modial.local:4001',
      'staging.customer.salesdue.com',
      'staging.customer.salesdue.com',
      'staging.retail.salesdue.com',
      'retail.salesdue.com',
      '127.0.0.1:8080',
      '127.0.0.1:4002',
      '127.0.0.1:4001',
      'localhost:4002',
      'localhost:4001',
      'portal.salesdue.local:4002',
      'portal.salesdue.local:4001',
      'retail.salesdue.local:4002',
      'retail.salesdue.local:4001',
    ]
  },
  {
    name: 'contractor',
    dashboardUrl: '/dashboard',
    dashBoardPermission: 'DASHBOARD_PAYMENTS_READ',
    modules: [
      "dashboard",
      "analytics",
      "customers",
      "products",
      "quotations",
      "invoices",
      "recurringInvoices",
      "creditNotes",
      "debitNotes",
      'receipts',
      'statement',
      "bills",
      "cashPurchases",
      "suppliers",
      "accounting",
      "reports",
      "profile",
      "settings",
      "more",
      'communications',
      'projects',
    ],
    domains: [
      'contractor.salesdue.com',
      'contractor.salesdue.local:4002',
      'contractor.salesdue.local:4001',
    ]
  },
  {
    name: 'fastatext',
    dashboardUrl: '/dashboard/sms',
    dashBoardPermission: 'DASHBOARD_SMS_READ',
    modules: [
      "dashboard",
      "customers",
      'statement',
      "marketing",
      "bills",
      "cashPurchases",
      "suppliers",
      "email",
      "profile",
      "settings",
      'communications',
      'projects',
    ],
    domains: [
      'fastatext.com',
      'www.fastatext.com',
      'app.fastatext.com',
      'sms.salesdue.com',
      'sms.salesdue.local:4002',
      'sms.salesdue.local:4001',
    ]
  },
  {
    name: 'school',
    dashboardUrl: '/dashboard',
    dashBoardPermission: 'DASHBOARD_PAYMENTS_READ',
    modules: [
      "dashboard",
      "analytics",
      "owners",
      "customers",
      "products",
      "invoices",
      "recurringInvoices",
      "creditNotes",
      "debitNotes",
      "accounting",
      "bills",
      "suppliers",
      'receipts',
      'statement',
      "bills",
      "cashPurchases",
      "suppliers",
      "email",
      "profile",
      "settings",
      "reports",
      "more",
      'communications',
      'projects',
    ],
    domains: [
      'school.salesdue.com',
      'parents.schoolkeeper.io',
      'parents-test.schoolkeeper.io',
      'parents.remedialschool.org',
      'staging.school.salesdue.com',
      'school.salesdue.local:4002',
      'school.salesdue.local:4001',
    ]
  },
  {
    name: 'levies',
    dashboardUrl: '/dashboard',
    dashBoardPermission: 'DASHBOARD_PAYMENTS_READ',
    modules: [
      "dashboard",
      "analytics",
      "owners",
      'cabinMasters',
      "contractors",
      'visitors',
      'visits',
      "customers",
      "accounting",
      "products",
      "categories",
      "invoices",
      "recurringInvoices",
      "creditNotes",
      "debitNotes",
      'receipts',
      'statement',
      "bills",
      "email",
      "profile",
      "settings",
      "reports",
      "premises",
      "more",
      'communications',
      'projects',
    ],
    domains: [
      'levies.salesdue.com', 'residents.estatekeeper.io',
      'estate.salesdue.com',
      'staging.estate.salesdue.com',
      'estate.arlingtoneast.co.zw',
      'levies.salesdue.local:4002',
      'levies.salesdue.local:4001',
      'ecs-frontend-vue-psi.vercel.app'
    ]
  },
  {
    name: 'medical',
    dashboardUrl: '/dashboard',
    dashBoardPermission: 'DASHBOARD_PAYMENTS_READ',
    modules: [
      "dashboard",
      "analytics",
      "medical-contacts",
      'admissions',
      'appointments',
      "customers",
      "quotations",
      "products",
      "accounting",
      "invoices",
      "recurringInvoices",
      "creditNotes",
      "debitNotes",
      'receipts',
      'statement',
      'claims',
      "reports",
      "categories",
      "bills",
      "cashPurchases",
      "suppliers",
      "suppliers",
      "brands",
      "email",
      "profile",
      "settings",
      "more",
      'communications',
      'projects',
    ],
    domains: [
      'medical.salesdue.com',
      'patients.modial.health',
      'staging.medical.salesdue.com',
      'medical.salesdue.local:4002',
      'medical.salesdue.local:4001'
    ]
  },
  {
    name: 'personal',
    dashboardUrl: '/dashboard',
    dashBoardPermission: 'DASHBOARD_PAYMENTS_READ',
    modules: [
      "dashboard",
      "customers",
      "products",
      "invoices",
      "recurringInvoices",
      "creditNotes",
      "debitNotes",
      "accounting",
      'receipts',
      'statement',
      "bills",
      "cashPurchases",
      "suppliers",
      "suppliers",
      "brands",
      "reports",
      "categories",
      "profile",
      "settings",
      "more",
      'communications',
      'projects',
    ],
    domains: [
      'personal.salesdue.com',
      'staging.personal.salesdue.com',
      'personal.salesdue.local:4002',
      'personal.salesdue.local:4001'
    ]
  }
]



// WEBPACK FOOTER //
// ./src/utils/modules.js